import { useState, useLayoutEffect, useRef } from 'react';

export const useContainerSize = () => {
    const [ dimensions, setDimensions ] = useState({ width: 0, height: 0 });
    const ref = useRef(null);

    useLayoutEffect(() => {
        if (!ref.current) return;

        const observer = new ResizeObserver(([entry]) => {
            setDimensions({
                width: entry.contentRect.width,
                height: entry.contentRect.height
            });
        });

        observer.observe(ref.current);
        return () => observer.disconnect();
    },[]);

    return [ref, dimensions];
};